import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgSunRaiseOutline = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="-.5 -.5 16 16"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    {desc === undefined ? (
      <desc id={descId}>
        {"\n    Sun Fog Streamline Icon: https://streamlinehq.com\n  "}
      </desc>
    ) : desc ? (
      <desc id={descId}>{desc}</desc>
    ) : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4.7651 14.3372h5.4698M2.714 12.286h9.572M.6628 10.2349h13.6744"
    />
    <path
      stroke="currentColor"
      d="M7.5 3.3977c-2.2656 0-4.1023 1.8367-4.1023 4.1023a4.087 4.087 0 0 0 1.0256 2.7135h6.1534A4.087 4.087 0 0 0 11.6024 7.5c0-2.2656-1.8367-4.1023-4.1023-4.1023Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      d="M7.5.6628v.6837M14.3372 7.5h-.6837M1.3465 7.5H.6628M12.3344 2.6656l-.2685.2685M2.934 2.934l-.2686-.2686"
    />
  </svg>
);
export default SvgSunRaiseOutline;
